import { render, staticRenderFns } from "./CierreCambioVentana.vue?vue&type=template&id=5d60874e"
import script from "./CierreCambioVentana.vue?vue&type=script&lang=js"
export * from "./CierreCambioVentana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports